<template>
  <div class="create">
    <form
      class="form"
      @submit.prevent="onSubmit"
    >
      <p class="h2">Создание пользователя</p>

      <InputWrapper title="Имя">
        <BaseInput v-model="form.name" />
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.name.required.$invalid">
          Заполните это поле.
        </InvalidFeedback>
      </InputWrapper>

      <InputWrapper title="Почта">
        <BaseInput v-model="form.email" />
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.email.email.$invalid">
          Не валидный адрес почты.
        </InvalidFeedback>
      </InputWrapper>

      <InputWrapper title="Телефон">
        <BaseInput
          v-mask="phoneMask"
          v-model="form.phone"
        />
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.phone.required.$invalid">
          Заполните это поле.
        </InvalidFeedback>
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.phone.isCorrectly.$invalid">
          Не корректный номер телефона.
        </InvalidFeedback>
      </InputWrapper>

      <InputWrapper title="Логин">
        <BaseInput v-model="form.username" />
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.username.required.$invalid">
          Заполните это поле.
        </InvalidFeedback>
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.username.minLength.$invalid">
          Логин не может быть короче {{ v$.form.username.minLength.$params.min }} символов.
        </InvalidFeedback>
      </InputWrapper>

      <InputWrapper title="Пароль">
        <BaseInput v-model="form.password" />
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.password.required.$invalid">
          Заполните это поле.
        </InvalidFeedback>
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.password.minLength.$invalid">
          Пароль не может быть короче {{ v$.form.password.minLength.$params.min }} символов.
        </InvalidFeedback>
      </InputWrapper>

      <InputWrapper title="Роль">
        <BaseSelect
          v-model="form.role"
          :options="options.roles"
        />
        <InvalidFeedback v-if="v$.form.$dirty && v$.form.role.required.$invalid">
          Заполните это поле.
        </InvalidFeedback>
      </InputWrapper>

      <div class="btn-container">
        <BaseButton style="height: 60px;">
          ДОБАВИТЬ
        </BaseButton>
        <BaseButton
          style="height: 60px;"
          theme="simple"
          type="reset"
          @click="resetValues"
        >
          Сбросить
        </BaseButton>
      </div>
    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, minLength, email } from '@vuelidate/validators'
import { parsePhone } from '@/utils/functions'
import { phoneMask } from '@/constants'

import BaseInput from '@/components/Base/BaseInput'
import BaseButton from '@/components/Base/BaseButton'
import InvalidFeedback from '@/components/InvalidFeedback'
import BaseSelect from '@/components/Base/BaseSelect'
import InputWrapper from '@/components/InputWrapper'

export default {
  name: 'create-user',
  components: {
    InputWrapper,
    BaseSelect,
    InvalidFeedback,
    BaseButton,
    BaseInput
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data () {
    return {
      phoneMask,
      options: {
        roles: [
          { value: 'ROLE_MANAGER', text: 'Управляющий' },
          { value: 'ROLE_ADMIN', text: 'Администратор' }
        ]
      },
      form: {
        name: '',
        email: '',
        phone: '',
        username: '',
        password: '',
        role: 'ROLE_MANAGER'
      }
    }
  },
  computed: {
    requestBody () {
      return {
        name: this.form.name,
        username: this.form.username,
        email: this.form.email,
        phone: parsePhone(this.form.phone),
        password: this.form.password,
        role: this.form.role
      }
    }
  },
  methods: {
    async onSubmit () {
      if (this.v$.form.$invalid) {
        this.v$.form.$touch()
        return
      }

      try {
        const { data } = await this.$api.user.createUser(this.requestBody)
        this.$router.push('/user/' + data.id)
      } catch (e) {
        console.log(e)
      }
    },
    resetValues () {
      return setImmediate(() => {
        this.form.name = ''
        this.form.email = ''
        this.form.phone = ''
        this.form.username = ''
        this.form.password = ''
        this.form.role = 'ROLE_MANAGER'

        this.v$.form.$reset()
      })
    }
  },
  validations () {
    return {
      form: {
        name: {
          required
        },
        email: {
          email
        },
        phone: {
          required,
          isCorrectly: function (val) {
            return val.length === 18
          }
        },
        username: {
          required,
          minLength: minLength(8)
        },
        password: {
          required,
          minLength: minLength(8)
        },
        role: {
          required
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.create {
  display: block;
  max-width: 600px;

  .form {
    label {
      display: block;
      margin-top: 20px;

      span {
        display: block;
        margin-bottom: 6px;
      }
    }

    .btn-container {
      margin-top: 20px;
    }
  }
}
</style>
